var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFromTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27,
    height: 27,
    rx: 4,
    fill: "#3CC491"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    width: 27,
    height: 27,
    rx: 4,
    fill: "#EBF9F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 39,
    width: 27,
    height: 27,
    rx: 4,
    fill: "#EBF9F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 39,
    width: 27,
    height: 27,
    rx: 4,
    fill: "#3CC491"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFromTemplate);
export default __webpack_public_path__ + "static/media/add_from_template.639e04b4eab5938e92cd54a6dc3bcc27.svg";
export { ForwardRef as ReactComponent };